<section class="filter-section" *ngIf="hasAvailableOptions">
  <div class="filter-header-row" (click)="toggleSection()">
    <h3 class="filter-header">{{ title }}</h3>

    <div class="filter-header-actions">
      <input
        *ngIf="!isCollapsed && shouldShowSearchInput"
        type="search"
        class="facet-search"
        [placeholder]="searchPlaceholder"
        [ngModel]="filterText"
        (ngModelChange)="onFilterInput($event)"
        (click)="$event.stopPropagation()"
      />

      <button
        type="button"
        class="facet-toggle"
        (click)="toggleSection(); $event.stopPropagation()"
        [attr.aria-expanded]="!isCollapsed"
        [attr.aria-label]="toggleLabel"
        [attr.title]="toggleLabel"
      >
        <span class="facet-toggle-icon" [class.is-expanded]="!isCollapsed" aria-hidden="true">
          <svg class="drop-icon" display="block" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.9133 8.1633L10.6633 14.4133C10.5762 14.5007 10.4727 14.57 10.3587 14.6174C10.2448 14.6647 10.1226 14.689 9.99922 14.689C9.87583 14.689 9.75365 14.6647 9.6397 14.6174C9.52574 14.57 9.42225 14.5007 9.33515 14.4133L3.08515 8.1633C2.90903 7.98718 2.81009 7.74831 2.81009 7.49923C2.81009 7.25016 2.90903 7.01129 3.08515 6.83517C3.26127 6.65905 3.50014 6.56011 3.74922 6.56011C3.99829 6.56011 4.23716 6.65905 4.41328 6.83517L10 12.4219L15.5867 6.83439C15.7628 6.65827 16.0017 6.55933 16.2508 6.55933C16.4998 6.55933 16.7387 6.65827 16.9148 6.83439C17.091 7.01051 17.1899 7.24938 17.1899 7.49845C17.1899 7.74752 17.091 7.9864 16.9148 8.16252L16.9133 8.1633Z" fill="currentColor"></path>
          </svg>
        </span>
      </button>
    </div>
  </div>

  <ng-container *ngIf="!isCollapsed">
    <ul class="filter-list">
      <li *ngFor="let item of visibleItems">
        <label class="facet-option" [class.is-selected]="selectedValues.includes(item.value)">
          <input
            type="checkbox"
            [checked]="selectedValues.includes(item.value)"
            (change)="onToggleValue(item.value)"
          />
          <span class="facet-option-label">{{ item.label | capitalize }}</span>
          <span class="facet-option-count">{{ item.count | number: '1.0-0' }}</span>
        </label>
      </li>
    </ul>

    <div *ngIf="items.length === 0 && hasFilterText" class="facet-no-results">
      {{ translate('noFacetResults') }}
    </div>

    <button
      *ngIf="canShowMore || canShowLess"
      type="button"
      class="facet-show-more"
      (click)="canShowMore ? showMore() : showLess()"
    >
      {{ canShowMore ? translate('showMore') : translate('showLess') }}
    </button>
  </ng-container>
</section>
